import { render, staticRenderFns } from "./HotelView.vue?vue&type=template&id=5c721fe0&"
import script from "./HotelView.vue?vue&type=script&lang=js&"
export * from "./HotelView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports